// extracted by mini-css-extract-plugin
export var addToCart = "patternDetails-module--addToCart--ae1cc";
export var container = "patternDetails-module--container--86b67";
export var ctaSection = "patternDetails-module--ctaSection--252d7";
export var description = "patternDetails-module--description--c835a";
export var imagesContainer = "patternDetails-module--imagesContainer--58655";
export var initialPrice = "patternDetails-module--initialPrice--849da";
export var mainImage = "patternDetails-module--mainImage--5b1c4";
export var mainPrice = "patternDetails-module--mainPrice--d5930";
export var mobileHeader = "patternDetails-module--mobileHeader--6636e";
export var secondaryImage = "patternDetails-module--secondaryImage--6957a";
export var secondaryImagesContainer = "patternDetails-module--secondaryImagesContainer--48fb7";
export var subHeader = "patternDetails-module--subHeader--949a6";
export var subSection = "patternDetails-module--subSection--35341";
export var textContainer = "patternDetails-module--textContainer--2c5c6";